import { Box, Divider, Skeleton, Stack } from "@mui/material";

const FeedSkeleton = () => {
  return (
    <Stack divider={<Divider variant="dashed" sx={{ mx: 1 }} />}>
      {[...new Array(2)].map((_, i) => (
        <Stack key={i} direction="row" spacing={1} sx={{ alignItems: "center", p: 1 }}>
          <Skeleton variant="circular" width={36} height={36} />
          <Box>
            <Skeleton width={220} height={24} />
            <Skeleton width={50} height={24} />
          </Box>
        </Stack>
      ))}

      <Stack sx={{ backgroundColor: "rgba(0, 0, 0, 0.03)", p: 1 }}>
        <Skeleton width={50} height={24} />
        <Skeleton width={220} height={24} />
      </Stack>
    </Stack>
  );
};

export { FeedSkeleton };
